module.exports = __webpack_public_path__ + "img/px2pt.d2bff970.png";